import React, { useEffect, useState } from "react";
import "./LeaderboardTable.css";
import { useBalance, useAccount } from "wagmi";


const LeaderboardTable = ({data}) => {
  const [leaders, setleaders] = useState([]);
  var { address } = useAccount();
  //console.log(data)
  const [array1, array2, array3] = data;


  useEffect(() => {
    if (!address) address='0x0000000000000000000000000000000000000000'

    async function main() {   
      if (!array3)return;
      console.log(array3)
  const uniqueArray = [array3][0].reduce((acc, current) => {
    const x = acc.find(item => item.address === current.address);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);

  // Sort by amount (converted to decimal from hexadecimal)
  const sortedArray = uniqueArray.sort((a, b) => {
    const numA = Number(a.amount); 
    const numB = Number(b.amount); 
    return numB - numA; 
  });
    setleaders(sortedArray)

    }
    main();
  }, [data]);


  function shortAddress(address) {
    console.log(address)
    return address.substring(0, 6) + "..." + address.substring(address.length - 4);
  }
  return (
    <div className="lg:w-full mt-[29px]   table-top-wrap flex justify-center text-center">
      <div className=" overflow-x-scroll lg:overflow-hidden max-w-[1216px] w-full">
        <table
          cellSpacing="0"
          cellPadding="0"
          className="min-w-[900px] leader w-full px-[200px]"
        >
          <thead className="h-[48px]  ">
            <tr>
              <th className="rounded-tl-[10px]">RANK</th>
              <th>ADDRESS</th>
              <th>ETH DEPOSITED</th>
              <th className="rounded-tr-[10px]">ACTION</th>
            </tr>
          </thead>
          <tbody className="text-res-xs font-semibold" >
    
          {leaders&&leaders[0]&&leaders.map((data, i) => (

              <tr key={i} >
                <td style={{paddingBottom:'12px',paddingTop:'12px'}}>
               
                  {i + 1}
                </td>
         
                <td style={{paddingBottom:'12px',paddingTop:'12px'}}>{shortAddress(data.address)}</td>
                <td style={{paddingBottom:'12px',paddingTop:'12px'}}>{Number(data.amount)/10**18}</td>
                <td style={{paddingBottom:'12px',paddingTop:'12px'}}>
                  <button>View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaderboardTable;
